const BANNER_KEY = 'b2b-banners';

export default {

    save(list) {
        let data = {
            expire: new Date().getTime(),
            banners: list
        };
        window.localStorage.setItem(BANNER_KEY, JSON.stringify(data));
    },

    load() {
        let data = window.localStorage.getItem(BANNER_KEY);
        if (data) {
            let result = JSON.parse(data);
            if(this.compareTime(result.expire)) {
                return result.banners;
            }
        }
        return false;
    },

    compareTime(time) {
        let now = new Date().getTime();
        let diff = now - time;
        return diff < 3600000;
    },

    clear() {
        window.localStorage.removeItem(BANNER_KEY);
    }
}


// WEBPACK FOOTER //
// ./src/components/banners/src/BannerStorage.js